const faqs = [
  {
    q: '蘑菇影视需要注册登录吗？',
    a: '不需要。蘑菇影视坚持免费开放观影，访问官网首页入口即可直接观看电影、电视剧、综艺和动漫内容，无需注册账号，更不需要提供任何个人信息。',
  },
  {
    q: '播放时为什么会缓冲？如何解决？',
    a: '蘑菇影视采用智能CDN加速技术，正常情况下播放流畅不缓冲。如遇缓冲，建议检查网络连接状况或切换清晰度档位。平台自适应码率功能会根据网络状况自动优化播放体验。',
  },
  {
    q: '手机端可以正常观看吗？',
    a: '完全支持。蘑菇影视官网已针对手机浏览器进行全面适配，iOS和Android系统均可流畅访问。无需下载任何应用，打开浏览器输入网址即可随时随地免费在线观看高清内容。',
  },
  {
    q: '内容更新频率如何？能找到最新剧集吗？',
    a: '平台内容编辑团队每日更新资源，热门电影和电视剧通常在上线后第一时间同步更新。追剧用户可以通过热播榜单和精选推荐模块快速找到最新更新的内容。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-4">
          常见问答
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          关于蘑菇影视的使用，这里有你想要的答案
        </p>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/60 rounded-lg p-5 md:p-6"
            >
              <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2 flex items-start gap-3">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">Q</span>
                <span>{faq.q}</span>
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-8">
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}